import React, { useEffect, useState } from 'react';
import { PHSHeader } from '../../components/UI/header';
import DataTable from '../../components/UI/table';
import { styles } from './index.sass';
import { Button, Modal } from 'antd';
import { SendOutlined, CheckCircleTwoTone, ClockCircleTwoTone } from '@ant-design/icons';
import { getSessionAlerts, sendSessionAlertEmail } from '../../api/sessionAlert';
import { SESSION_ALERT_EMAIL_TEMPLATE, SESSION_ALERT_EMAIL_TYPE } from '../../utils/constant';

export const SessionPurchaseEmails = () => {
    const [loading, setLoading] = useState(false);
    const [emails, setEmails] = useState([]);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [emailContent, setEmailContent] = useState('');

    const columns = [
        {
            title: 'Status',
            dataIndex: 'is_approved',
            key: 'is_approved',
            render: (is_approved) => {
                if (is_approved === true || is_approved === 1) {
                    return <CheckCircleTwoTone twoToneColor="#52c41a" title="Sent" />;
                }
                return <ClockCircleTwoTone twoToneColor="#faad14" title="Pending" />;
            }
        },
        { title: 'Person Id', dataIndex: 'person_id', key: 'person_id' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Type', key: 'email_type', render: ({ email_type }) => SESSION_ALERT_EMAIL_TYPE[email_type] || '' },
        {
            key: 'actions',
            title: 'Actions',
            render: (text, record) => {
                return (
                    <div>
                        <Button
                            type="default"
                            onClick={() => onClickOpenEmailModal(record)}
                            disabled={text.is_approved === true || text.is_approved === 1}
                        >
                            <SendOutlined />
                        </Button>
                    </div>
                )
            }
        }
    ];

    const fetchSessionAlerts = async () => {
        setLoading(true);
        const emails = await getSessionAlerts();
        setEmails(emails);
        setLoading(false);
    }

    const onClickOpenEmailModal = (record) => {
        setEmailContent(SESSION_ALERT_EMAIL_TEMPLATE.replace('[Client Name]', record.name))
        setSelectedEmail(record);
    }

    const onClickSendEmail = async () => {
        setLoading(true);
        await sendSessionAlertEmail({
            subject: 'Apeiron Life: Sessions Alert',
            email_content: emailContent,
            person_id: selectedEmail.person_id,
            id: selectedEmail.id
        })
        setLoading(false);
        setSelectedEmail(null);
        fetchSessionAlerts();
    }

    useEffect(() => {
        fetchSessionAlerts();
    }, []);

    return (
        <div className={styles}>
            <div className='container'>
                <h2>Session Purchase Emails</h2>
                <div>
                    <DataTable
                        columns={columns || []}
                        dataSource={emails || []}
                        loading={loading}
                        hidePagination={true}
                    />
                </div>
                <Modal
                    open={selectedEmail !== null}
                    onCancel={() => setSelectedEmail(null)}
                    onOk={onClickSendEmail}
                >
                    <div>
                        <div>Send Email</div>
                        <div>
                            <div>
                                <textarea value={emailContent} onChange={(e) => setEmailContent(e.target.value)}
                                    placeholder='Email Content' rows={10} cols={50} />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </div >
    )
}